import Modal from "./Modal";
import ModalButton from "./ModalButton";
import ModalInfo from "./ModalInfo";
import * as LargeModalStyling from "./LargeModalStyling";
import * as ModalText from "./ModalText";
import * as ModalLayout from "./ModalLayout";
import * as MoreModalButtons from "./MoreModalButtons";

export default Modal;
export {
  ModalButton,
  ModalInfo,
  ModalText,
  ModalLayout,
  LargeModalStyling,
  MoreModalButtons,
};
